import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContentLayoutComponent } from './layouts/content/content-layout.component';
import { FullLayoutComponent } from './layouts/full/full-layout.component';
import { PaymentLayoutComponent } from './layouts/payment/payment-layout.component';
import { AuthenticationGuard } from './shared/authentication/authentication-guard.service';
import { ContentLayoutRoutes } from './shared/routes/content-layout.routes';
import { FullLayoutRoutes } from './shared/routes/full-layout.routes';
import { PaymentLayoutRoutes } from './shared/routes/payment-layout.routes';

const routes: Routes = [];

const appRoutes: Routes = [
  {
    path: '',
    component: FullLayoutComponent,
    data: {title: 'full Views'},
    children: FullLayoutRoutes,
    canActivate: [AuthenticationGuard]
  },
  {path: '', component: ContentLayoutComponent, data: {title: 'content Views'}, children: ContentLayoutRoutes},
  {path: '', component: PaymentLayoutComponent, data: {title: 'content Views'}, children: PaymentLayoutRoutes}
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, {relativeLinkResolution: 'legacy'})],
  exports: [RouterModule]
})


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
